import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { CardComp, ButtonComp } from "..";
import { convertToTitleCase } from "../../utils/helpers";
import { withProfileVerificationQuery } from "../../utils/investorRouteHelpers";
import { investorButtonProps } from "./investorButtonStyles";

const STATUS_STYLES = {
  none: { bg: "var(--color-primary-soft)", color: "#da6900", label: "Not verified" },
  pending: { bg: "#fcefe2", color: "#ff9500", label: "Pending review" },
  under_review: { bg: "#fcefe2", color: "#ff9500", label: "Under review" },
  approved: { bg: "#dafceb", color: "#19bc31", label: "Verified" },
  rejected: { bg: "#e0a8ae", color: "#ff4343", label: "Verification failed" },
  resubmission_required: { bg: "#fcefe2", color: "#da6900", label: "Resubmission required" },
};

const Banner = styled.div`
  margin-bottom: 1.5rem;
  border-radius: 10px;
  border: 1px solid ${(p) => p.$border || "#e5e5e5"};
  background: ${(p) => p.$bg || "#fff"};
  overflow: hidden;
`;

export default function KycBanner({ status = "none", redirectTo = "/invest/dashboard", intent, itemId }) {
  const navigate = useNavigate();
  if (status === "approved") return null;

  const style = STATUS_STYLES[status] || STATUS_STYLES.none;
  const kycLink = withProfileVerificationQuery({
    redirect: redirectTo,
    intent,
    itemId,
  });

  return (
    <Banner $bg={style.bg} $border={style.color} className="kyc-banner">
      <CardComp cardClassName="border-0 bg-transparent mb-0 pb-0" cardBodyClassName="py-3 px-3 px-md-4">
        <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
          <div>
            <p className="fw-semibold mb-1" style={{ color: style.color }}>
              Identity verification: {convertToTitleCase(style.label)}
            </p>
            <p className="text-muted small mb-0">
              Complete NIN verification to invest, order from the marketplace, and submit requests.
            </p>
          </div>
          <div className="flex-shrink-0" style={{ minWidth: "min(100%, 160px)" }}>
            <ButtonComp
              btnText={
                status === "rejected" || status === "resubmission_required"
                  ? "Retry verification"
                  : "Verify now"
              }
              onClick={() => navigate(kycLink)}
              {...investorButtonProps.primaryInline}
            />
          </div>
        </div>
      </CardComp>
    </Banner>
  );
}
